import Customers from "../pages/Customers/Customers";
import Stores from "../pages/Stores/Stores";

const adminRoutes = [
  { path: "/admin/customers", component: Customers },
  { path: "/admin/stores", component: Stores },
];

export default adminRoutes;
